import { createFileRoute } from '@tanstack/react-router';
import { AutomationsDraftsForward } from '@/pages/workspaces/automations/[campaignId]/drafts/routing';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/drafts')({
  component: AutomationsDraftsForward,
});
